import React from 'react';
import { X, CheckCircle, AlertCircle } from 'lucide-react';
import { cn } from '../../utils/cn';
import Button from './Button';

export const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  confirmText = 'Confirm',
  onConfirm,
  cancelText = 'Cancel',
  hideActions = false,
  type = 'default',
  className
}) => {
  if (!isOpen) return null;

  const getTypeIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="w-5 h-5 text-reddit-green" />;
      case 'error':
        return <AlertCircle className="w-5 h-5 text-reddit-red" />;
      default:
        return null;
    }
  };

  return (
    <>
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={onClose}
      />
      <div className="fixed inset-0 flex items-center justify-center p-4 z-50 pointer-events-none">
        <div className={cn(
          'bg-white dark:bg-dark-card rounded-lg p-6 w-full max-w-md',
          'border border-reddit-200 dark:border-dark-border',
          'shadow-lg pointer-events-auto',
          className
        )}>
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-3">
              {getTypeIcon()}
              <h3 className="text-lg font-semibold">{title}</h3>
            </div>
            <button 
              onClick={onClose}
              className="text-reddit-600 dark:text-dark-textMuted hover:text-reddit-900 dark:hover:text-dark-text transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="mb-6">
            {children}
          </div>

          {!hideActions && (
            <div className="flex justify-end gap-3">
              <Button variant="outline" onClick={onClose}>
                {cancelText}
              </Button>
              {onConfirm && (
                <Button variant="primary" onClick={onConfirm}>
                  {confirmText}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};